import { useCallback, useState } from 'react';
import axios from 'axios';
import { useGet_Image_Upload_LinkMutation } from '@geerd-nx/shareable-graphql';

export function useUploadImage(
  variant: string,
  CLOUDFLARE_IMAGE_PREFIX: string
) {
  const [progress, setProgress] = useState(0);
  const [getImageUploadLink] = useGet_Image_Upload_LinkMutation();

  const uploadImage = useCallback(async function ({
    file,
  }: {
    file: string | Blob;
  }) {
    const result = await getImageUploadLink();

    const { data } = result;
    const url = data?.image_upload?.uploadURL ?? '';
    const image_id = data?.image_upload?.id;
    // -- create form data
    const formData = new FormData();
    formData.append('file', file);
    // -- post
    await axios.post(url, formData, {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setProgress(percentCompleted);
        if (percentCompleted === 100) {
          setProgress(0);
        }
        // console.log("progress", percentCompleted);
      },
    });

    // -- resource url
    return `${CLOUDFLARE_IMAGE_PREFIX}/${image_id}/${variant}`;
  },
  []);
  return { uploadImage, progress };
}
